import { useCallback, useEffect, useState } from 'react';
import { getPolicy } from '../services/policies';
import { isKnownPolicyType, mapPolicy } from '../utils/contentMappers';

export function usePolicy(type) {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPolicy = useCallback(async () => {
    if (!type || !isKnownPolicyType(type)) {
      setPolicy(null);
      setError('Policy not found.');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getPolicy(type);

      if (response?.success === false) {
        setPolicy(mapPolicy(response, type));
        setError(response?.message || 'Policy not found.');
        return;
      }

      const mapped = mapPolicy(response, type);

      if (!mapped.content) {
        setPolicy(mapped);
        setError('Policy content is unavailable right now.');
        return;
      }

      setPolicy(mapped);
    } catch (e) {
      setPolicy(null);
      setError(e?.message || 'Failed to load policy');
    } finally {
      setLoading(false);
    }
  }, [type]);

  useEffect(() => {
    fetchPolicy();
  }, [fetchPolicy]);

  return { policy, loading, error, refetch: fetchPolicy };
}
